export default "__VITE_ASSET__Xu0Jko9R__"